'use strict';

window.ranger = window.ranger || {};

/**
 * Handles the Home and Feed UI.
 */
ranger.Quiz = class {

  /**
   * Initializes the Friendly Pix feeds.
   * @constructor
   */
  constructor() {

    window.currentSlide = 0;
    window.answerShown = false;
    // Firebase SDK.
    this.auth = firebase.auth();
    this.database = firebase.database();
    this._waitForAuthPromiseResolver = new $.Deferred();
    this.myQuestions = [];

    $(document).ready(() => {
      // Pointers to DOM elements.
      this.quizContainer = $('#quiz');
      this.resultsContainer = document.getElementById("results");
      this.previousButton = document.getElementById("previous");
      this.nextButton = document.getElementById("next");
      this.reasonContainer = $('.reason');
      this.slides = '';

      this.previousButton.addEventListener("click", this.showPreviousSlide);
      this.nextButton.addEventListener("click", this.showNextSlide);
      let isMouseDown = false;

      $('#page-quiz').on('mousedown', '.dynamic', function() {
        isMouseDown = true;
        $(this).toggleClass('mdl-color--orange');
      });

      $('#page-quiz').on('mouseover', '.dynamic', function() {
        if (isMouseDown) {
          $(this).toggleClass('mdl-color--orange');
        }
      });

      $('#page-quiz').on('mouseup', '.dynamic', function() {
        isMouseDown = false;
      })
      $('#page-quiz').on('mouseleave', 'table', function() {
        isMouseDown = false;
      })

      /** Video Quiz **/
      window.currentQuestionNo = 0;
      $('#quiz').on('click', 'li.video', function() {
        ranger.quiz.checkVideoAnswer($(this).data('id'));
      });
      $('.rewind').click(function() {
        video.currentTime(video.currentTime - 60);
        $(this).hide();
        $('#question').hide();
        player.play();
      })

    });

  }

  nextQuestions() {
    window.currentQuestionNo++;
    $('.continue').hide();
    $('#question').hide();

    window.player.play();
    if (window.currentQuestionNo < window.videoQuestions.length) {
      ranger.quiz.showQuestion(window.videoQuestions[window.currentQuestionNo]);
      ranger.quiz.setupListener(window.videoListeners[window.currentQuestionNo]);
    } else {

    }
  }

  showQuestion(question) {
    $('.videoTable table').remove();
    $('.videoAnswers').empty();
    if (question.type === 'range') {
      $('#question .modal-dialog').addClass('modal-lg');
      $('.videoTable').append(returnTable(window.currentQuestionNo+'a', window.currentQuestionNo, 'a', 'video'))
    } else {
      $('#question .modal-dialog').removeClass('modal-lg');
      question.answers.forEach(function(value, index) {
        $('.videoAnswers').append('<li data-id="'+index+'" class="video list-group-item list-group-item-secondary">'+value+'</li>');
      });
    }
    $('.videoExplanation').html(question.explanation);
    $('.explanation').removeClass('bg-danger bg-success').hide();

    // START HERE MISSING QUESTIONS
    question.question = question.question.replace(/:c:/g,'<img class="quizCard" src="/images/club.png">');
    question.question = question.question.replace(/:d:/g,'<img class="quizCard" src="/images/diamond.png">');
    question.question = question.question.replace(/:s:/g,'<img class="quizCard" src="/images/spade.png">');
    question.question = question.question.replace(/:h:/g,'<img class="quizCard" src="/images/heart.png">');
    $('.videoQuestion').html(question.question);
  }
  showAnswer(type) {
    $('span.answerType').remove();
    if (type === true) {
      $('.explanation').show();
      $('.videoExplanation').prepend('<span class="answerType text-success">Correct: </span>')
    } else {
      $('.explanation').show();
      $('.videoExplanation').prepend('<span class="answerType text-danger">Wrong: </span>')
    }
    $('.continue').show();
  }

  loadPaths() {
    console.log('Implement Learning Paths');
  }
  checkVideoAnswer(answerID, element = '') {
    if (element != '') {
      var dataType = element.getAttribute('data-type');
    } else {
      dataType = '';
    }

    if (dataType === 'video') {
      window.answerShown = !window.answerShown;
      $('.radioCorrect').removeClass('radioCorrect');
      $('.radioWrong').removeClass('radioWrong');
      if (window.answerShown) {
        element.innerHTML = 'Hide Answer';
        window.videoQuestions[window.currentQuestionNo].answers[0].forEach(function(hand) {
          var handSelect;
          var handClass;

          if(hand.indexOf(':') >= 0) {
            handSelect = hand.match(/[a-zA-Z0-9]\w+/g);
            handClass = hand.substring(hand.indexOf(":")+1, hand.indexOf(":") + 3);
            if (handClass > 0) {
              $('table#'+window.currentQuestionNo+'a'+' .cid_'+handSelect).addClass('correctAnswerWeighted');
              var element = `<span title="${handClass}%" class="combo" style="width: ${handClass}%;"></span>`;
              $('.cid_'+handSelect).append(element);
            }
          } else {
            $('table#'+window.currentQuestionNo+'a'+' .cid_'+hand).addClass('correctAnswer');
            //$('.cid_'+hand).append('<span class="combo" style="width: 100%"></span>');
          }
        })
        $('.dynamic.mdl-color--orange').not('.correctAnswer').addClass('wrongAnswer');
        var wrong = $('.dynamic.mdl-color--orange').not('.correctAnswer');
        var missed = $('.dynamic.correctAnswer').not('.mdl-color--orange');
        console.log('Wrong ' + wrong.length + ' Missed - ' + missed.length)
        $('.dynamic.correctAnswer').not('.mdl-color--orange').addClass('missedAnswer');
        //html = `<p> ${window.videoQuestions[window.currentQuestionNo].reason}</p>`
        ranger.quiz.showAnswer(true);
      } else {
        element.innerHTML = 'Show Answer';
        $('.reason').html('');
        $('.correctAnswer').removeClass('correctAnswer');
        $('.wrongAnswer').removeClass('wrongAnswer');
        $('.missedAnswer').removeClass('missedAnswer');
        $('span.combo').remove();
        $('.correctAnswerWeighted').removeClass('correctAnswerWeighted');
        $('.explanation').hide();
      }
    } else {
      if (window.videoQuestions[window.currentQuestionNo].correct === answerID) {
        ranger.quiz.showAnswer(true)
      } else {
        ranger.quiz.showAnswer(false);
      }
    }

  }
  checkAnswer(answer) {
    window.answerShown = !window.answerShown;
    $('.radioCorrect').removeClass('radioCorrect');
    $('.radioWrong').removeClass('radioWrong');
    if (window.answerShown) {
      //Fix Answer Shown Error
    answer.innerHTML = 'Hide Answer';
    var answerID = answer.name || answer.dataset.name;
    var answerVal = answer.value || answer.dataset.value;
    var html = '';
    if (answer.dataset.type === 'dynamic') {
      $('span.combo').remove()
      this.myQuestions[answerID].answers[answerVal].forEach(function(hand) {
        var handSelect;
        var handClass;

        if(hand.indexOf(':') >= 0) {
          handSelect = hand.match(/[a-zA-Z0-9]\w+/g);
          handClass = hand.substring(hand.indexOf(":")+1, hand.indexOf(":") + 3);
          if (handClass > 0) {
            $('table#'+answerID+answerVal+' .cid_'+handSelect).addClass('correctAnswer correctAnswerWeighted');
            var element = `<span title="${handClass}%" class="combo" style="width: ${handClass}%;"></span>`;
            $('.cid_'+handSelect).append(element);
          }
        } else {
          $('table#'+answerID+answerVal+' .cid_'+hand).addClass('correctAnswer');
          //$('.cid_'+hand).append('<span class="combo" style="width: 100%"></span>');
        }
      })
      $('.dynamic.mdl-color--orange').not('.correctAnswer').addClass('wrongAnswer');
      $('.dynamic.correctAnswer').not('.mdl-color--orange').addClass('missedAnswer');
      html = `<p> ${this.myQuestions[answerID].reason}</p>`
    } else {

      if (answerVal == this.myQuestions[answerID].correctAnswer) {
        $(answer).parent().addClass('radioCorrect');
        html = `<h4><span class="mdl-color-text--green">Correct!</span></h4><p> ${this.myQuestions[answerID].reason}</p>`;
      } else {
        $(answer).parent().addClass('radioWrong');
        html = `<h4><span class="mdl-color-text--red">Wrong! </span></h4><p> ${this.myQuestions[answerID].reason}</p>`;
      }
    }
  } else {
    answer.innerHTML = 'Show Answer';
    $('.reason').html('');
    $('.correctAnswer').removeClass('correctAnswer');
    $('.wrongAnswer').removeClass('wrongAnswer');
    $('.missedAnswer').removeClass('missedAnswer');
    $('span.combo').remove();
    $('.correctAnswerWeighted').removeClass('correctAnswerWeighted');
  }

    $('.reason').html(html);
    //$('td:not(".correctAnswer")').css('opacity', '0.2');
  }
  loadQuestion(quizId = '') {
    /*if (this.auth.currentUser.isPro === false && quizId !='') {
      alert('Upgrade to Enable Quiz Hands');
      page('/');
    }*/

    if (quizId != '') {
      ranger.quiz.myQuestions = [];
      this.database.ref('quizzes/'+quizId).orderByChild('sort').on('child_added', function(data) {
        ranger.quiz.myQuestions.push(data.val());
        ranger.quiz.loadQuiz();
      })
    } else {
      this.database.ref().child('quizzes').child('-LHF4weVqEOh1J4TRPPG').once('value').then(function(data) {
        ranger.quiz.myQuestions = data.val();
        ranger.quiz.loadQuiz();
      })
    }
  }
  setupListener(time) {
    video.addEventListener("timeupdate", function _checkTime() {
        if (window.video.currentTime >= time) {
          player.pause();
          $('#question').show();
          video.removeEventListener("timeupdate", _checkTime, false);
        }
    }, false);
  }
  loadQuiz() {
  /*ranger.MaterialUtils.checkRole().then(function(data) {
      ranger.quiz.buildQuestions(data);
    }).catch(function(error) {
      ranger.quiz.buildQuestions(false);
    })*/
    this.buildQuestions(this.auth.currentUser.isPro);
  }
buildQuestions(isPro) {
  // we'll need a place to store the HTML output
  const output = [];
    const selectors = [];
  // for each question..
  $.each(ranger.quiz.myQuestions, function(questionNumber, currentQuestion) {
    if (currentQuestion.isPro && isPro === false) {
      swal({
        title: 'Pro Membership Required',
        text: 'Some questions require paid membership',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Upgrade',
        closeOnConfirm: true,
        showLoaderOnConfirm: true,
        allowEscapeKey: true
      }, () => {
        window.location.href = 'https://ranger.raiseyouredge.com';
      });
    } else {
      // we'll want to store the list of answer choices
      const answers = [];
      var html = '';
      var questionClass = 'hide'


      if (currentQuestion.type === 'videoQuiz') {
        window.videoQuiz = true;
        window.videoQuestions = currentQuestion.questions;
        window.videoListeners = currentQuestion.listeners;

        output.push(`<div class="slide" data-type="${currentQuestion.type}"><div class="videoContainer" style="position: relative;">
                  <video id="video-js" width="100%" height="100%">
                    <source src="${currentQuestion.videoURL}" type="video/youtube">
                  </video>
                  <div class="modal" tabindex="-1" role="dialog" id="question">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title videoQuestion"></h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body videoTable">
                        <ul class="list-group videoAnswers">

                        </ul>
                        </div>
                        <div class="modal-footer explanation" style="display: inherit;">
                        <p class="videoExplanation"></p>
                        <span class="col"><button type="button" class="btn btn-success continue btn-block" onclick="ranger.quiz.nextQuestions()">Continue</button></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>`);

      } else {
        // and for each available answer...
        for (var letter in currentQuestion.answers) {
          // ...add an HTML radio button
          if (currentQuestion.type === 'radio') {
            answers.push(
              `<label class="answers" for="ipt${questionNumber}${letter}">
              <input id="ipt${questionNumber}${letter}" type="radio" class="quizRadio" name="${questionNumber}" value="${letter}" onclick="ranger.quiz.checkAnswer(this)">
              <span class="">${currentQuestion.answers[letter]}</span></label>`
            );

          } else if (currentQuestion.type === 'rangeStatic') {
            answers.push(returnTable(questionNumber+letter, questionNumber, letter));
            currentQuestion.answers[letter].forEach(function(hand) {
              //Fix selecting Hands
              if (hand.indexOf(':') >= 0) {

              }
              selectors.push('table#'+questionNumber+letter+' .cid_'+hand);
            });
          } else if (currentQuestion.type === 'rangeDynamic') {
              answers.push(returnTable(questionNumber+letter, questionNumber, letter, 'dynamic'));

          } else if (currentQuestion.type === 'handBreakdown') {
            html = `<iframe class="replayerFrame" src="https://replayer.raiseyouredge.com/${currentQuestion.hh}">Replayer is blocked, check your settings</iframe>`;
            answers.push(returnTable(questionNumber+letter, questionNumber, letter, 'dynamic'));
          }
        }

        // add this question and its answers to the output
        currentQuestion.question = currentQuestion.question.replace(/:c:/g,'<img class="quizCard" src="/images/club.png">');
        currentQuestion.question = currentQuestion.question.replace(/:d:/g,'<img class="quizCard" src="/images/diamond.png">');
        currentQuestion.question = currentQuestion.question.replace(/:s:/g,'<img class="quizCard" src="/images/spade.png">');
        currentQuestion.question = currentQuestion.question.replace(/:h:/g,'<img class="quizCard" src="/images/heart.png">');

        output.push(
          `<div class="slide" data-type="${currentQuestion.type}">
             <div><h5 class="card-title text-center">${currentQuestion.question} </h5><hr /></div>
             <div class="hand-container floating"> ${html}</div>
             <div class="answer-text"> ${answers.join("")} </div>
           </div>`
        );
      }

    }
  });

  // finally combine our output list into one string of HTML and put it on the page
  this.quizContainer.html(output.join(""));
  this.slides = $('.slide');
  this.showSlide(0);
  if (window.videoQuiz === true) {
    window.player = new MediaElementPlayer('video-js', {
      features: ['playpause', 'current', 'volume', 'progress'],
      success: function(mediaElement, originalNode, instance) {
        window.video = document.getElementById('video-js');
        ranger.quiz.setupListener(window.videoListeners[window.currentQuestionNo], false);
      }
    });
    ranger.quiz.showQuestion(window.videoQuestions[0]);
  }
  selectors.forEach(function(hand) {
    $(hand).addClass('mdl-color--green');
  });
}
    showSlide(n) {
      this.slides[window.currentSlide].classList.remove("active-slide");
      this.slides[n].classList.add("active-slide");

      window.currentSlide = n;

      if (window.currentSlide === 0) {
        this.previousButton.disabled = true;
      } else {
        this.previousButton.disabled = false;
      }

      if (window.currentSlide === this.slides.length - 1) {
        this.nextButton.disabled = true;
      } else {
        this.nextButton.disabled = false;
      }
    }

    showNextSlide() {
      ranger.quiz.showSlide(currentSlide + 1);
      $('.reason').html('');
      $('.correctAnswer').removeClass('correctAnswer');
      $('.wrongAnswer').removeClass('wrongAnswer');
      $('.missedAnswer').removeClass('missedAnswer');
      $('.correctAnswerWeighted').removeClass('correctAnswerWeighted');
      $('span.combo').remove();
      window.answerShown = false;
      $('.checkAnswer').html('Show Answer');
    }

    showPreviousSlide() {
      ranger.quiz.showSlide(currentSlide - 1);
      $('.reason').html('');
      $('.correctAnswer').removeClass('correctAnswer');
      $('.wrongAnswer').removeClass('wrongAnswer');
      $('.missedAnswer').removeClass('missedAnswer');
      $('.correctAnswerWeighted').removeClass('correctAnswerWeighted');
      $('span.combo').remove();
      window.answerShown = false;
      $('.checkAnswer').html('Show Answer');
    }

}

ranger.quiz = new ranger.Quiz();
